// Converts strings like "some-string" to "Some String"
// Convert string arrays like ["some_string", "other"] to "Some String, Other"
angular.module('pl-shared')
  .filter('titleCase', function(_) {
    return function(input) {
      return _.map([].concat(input || []), function(item) { return _.startCase(item) }).join(', ')
    }
  })
